@if (data(); as d) {
  <div class="pc" role="alertdialog" data-testid="avia-price-changed-dialog" [attr.aria-labelledby]="titleId">
    <div class="pc-head">
      <h3 class="pc-title" [id]="titleId">{{ 'The price has changed' | translate }}</h3>
      <button
        type="button"
        class="pc-close"
        data-testid="avia-price-changed-close-button"
        [attr.aria-label]="'Close' | translate"
        (click)="choose('cancel')"
      >
        ×
      </button>
    </div>
    <div class="pc-body">
      <p class="pc-text" data-testid="avia-price-changed-message">
        @if (packageTotal(); as total) {
          {{
            'TOUR_FLIGHT_PRICE_CHANGED'
              | translate
                : {
                    old: together(oldTotal() | priceFormat: currency()),
                    new: together(newTotal() | priceFormat: currency()),
                    total: together(total | priceFormat: currency())
                  }
          }}
        } @else {
          {{
            'FLIGHT_PRICE_CHANGED'
              | translate
                : {
                    old: together(oldTotal() | priceFormat: currency()),
                    new: together(newTotal() | priceFormat: currency())
                  }
          }}
        }
      </p>
      <div class="pc-table">
        @if (label()) {
          <span class="pc-k">{{ 'Fare' | translate }}</span>
          <span data-testid="avia-price-changed-fare">{{ label() }}</span>
        }
        <span class="pc-k">{{ 'Was' | translate }}</span>
        <span class="pc-old" data-testid="avia-price-changed-old">{{ oldTotal() | priceFormat: currency() }}</span>
        <span class="pc-k">{{ 'Now' | translate }}</span>
        <span class="pc-new" data-testid="avia-price-changed-new">{{ newTotal() | priceFormat: currency() }}</span>
        <span class="pc-k">{{ 'Difference' | translate }}</span>
        <span class="pc-diff" data-testid="avia-price-changed-difference">
          +{{ difference() | priceFormat: currency() }}
        </span>
        @if (packageTotal(); as total) {
          <span class="pc-k">{{ 'New tour price' | translate }}</span>
          <span class="pc-new" data-testid="avia-price-changed-package-total">{{
            total | priceFormat: currency()
          }}</span>
        }
      </div>
      <div class="pc-alert">
        <span class="pc-code" data-testid="avia-price-changed-code">{{ code() }}</span>
        <app-avia-trace-id testIdPrefix="avia-price-changed" [activityId]="d.activityId" />
      </div>
      <div class="pc-actions">
        <button type="button" class="pc-link" data-testid="avia-price-changed-cancel-button" (click)="choose('cancel')">
          {{ 'Cancel' | translate }}
        </button>
        <button
          type="button"
          class="pc-ghost"
          data-testid="avia-price-changed-choose-fare-button"
          (click)="choose('other')"
        >
          {{ 'Choose another fare' | translate }}
        </button>
        <button
          type="button"
          class="pc-primary"
          data-testid="avia-price-changed-confirm-button"
          (click)="choose('accept')"
        >
          {{ 'Accept the new price' | translate }}
        </button>
      </div>
    </div>
  </div>
}
